export default __webpack_public_path__ + "static/media/homepage.2fbd2d8d.jpg";